<div class="row">
  <div class="col-12 col-md-8">
    <nsc-form-field-select
      idx="recepientselect_org"
      controlName="organization"
      placeholder="Select Organization"
      [group]="formGroup"
      [selectObjects]="values.organizations$.value"></nsc-form-field-select>
  </div>
  <div class="col-12 col-md-8" *ngIf="formGroup.controls['organizationNotInList'].enabled">
    <nsc-form-field-input
      idx="recepientselect_orgnotinlist"
      controlName="organizationNotInList"
      maxlength="60"
      placeholder="Enter an Organization"
      [group]="formGroup"></nsc-form-field-input>
  </div>

  <nsc-recipient-select-department
    class="col-12"
    [formGroup]="formGroup" *ngIf="!values.isEnrolledBefore"></nsc-recipient-select-department>
</div>
